// extracted by mini-css-extract-plugin
module.exports = {"menu":"AgreementsMenu_menu__le00z","menu-selected":"AgreementsMenu_menu-selected__pCo4i"};